import * as yup from 'yup'

yup.setLocale({
    mixed : {
		required : 'Campo requerido',
		number : 'Dato inválido'
	},
})
export const loginSchema = yup.object().shape({
	email : yup
		.string()
		.required('Ingresa tu email.')
		.email('Ingresa un email válido.'),
	password : yup
		.string()
		.required('Ingresa tu contraseña.'),
})
export const loginInitialValues = {
	email : '', 
    password : ''
}